import React from 'react';
import server from '../../../server';
import {Link} from "react-router-dom";
import $ from 'jquery';

class HourBox extends React.Component{
    constructor(props){
        super(props);
        this.state = {

        }
    }

    render(){
        return(
            <div onClick={this.props.onClick} 
                style={this.props.active ? {backgroundColor:"#0084C1", color:"white"} : {}} 
                class="home-schedule-grid__time"> {this.props.hour} </div>
        )
    }
}

class AppointmentBox extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            yesterday: new Date(),
            today: new Date(),
            tomorrow: new Date(),
            times:{"clinic":[], "home":[]},
            mode:"clinic",
            selectedTime:""
        };
    }

    componentWillMount(){
        this.state.yesterday.setDate(this.state.today.getDate() - 1);
        this.state.tomorrow.setDate(this.state.today.getDate() + 1);

        this.loadMainFisioterapistTimes();
    }

    loadMainFisioterapistTimes = () =>{
        let date = this.state.today.getFullYear() + "-" + (this.state.today.getMonth() + 1) + "-" + this.state.today.getDate();
        fetch(server.address + "/fisioterapists/1/available/" + date,{
            method:"GET"
        }).then(response => response.json().then(data =>{
            this.setState({times: data});
        }));
    }

    changeDate = (i) =>{
        let today = new Date(this.state.today);
        today.setDate(today.getDate() + i);

        let yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);

        let tomorrow = new Date(this.state.today);
        tomorrow.setDate(this.state.today.getDate() + i + 1);

        this.setState({today:today, yesterday:yesterday, tomorrow:tomorrow, times:{"clinic":[], "home":[]}}, this.loadMainFisioterapistTimes);
    }

    activateTime = (hour) =>{
        server.homeAppointmentData = {
            time:hour,
            date:this.state.today,
            mode:this.state.mode
        }

        this.setState({selectedTime:hour})
    }

    loadHourBoxes = () =>{
        return this.state.times[this.state.mode].map((hour) =>{
            return <HourBox key={hour} 
                            onClick={() => this.activateTime(hour)} 
                            hour={hour} 
                            active={this.state.selectedTime == hour}/>
        })
    }

    render(){
        let monthsLabel = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"]
        return(
            <div style={{marginLeft: 0}} class="t-middle__content content-box-bgc">
                <div class="result-search-filter-bar p-10">
                    <div class="mT-10">
                        <div class="date-picker jc-c">
                            <div onClick={() => this.changeDate(-1)} class="date-picker__button">
                                <div class="c-client-default">
                                    <i class="fa fa-angle-left"></i>
                                </div>
                            </div>
                            <div class="date-picker__before">
                                <div class="c-client-secondary">
                                    <div class="date">{this.state.yesterday.getDate()}</div>
                                    <div class="label">{monthsLabel[this.state.yesterday.getMonth()]}</div>
                                </div>
                            </div>
                            <div class="date-picker__current">
                                <div class="c-client-default">
                                    <div class="date">{this.state.today.getDate()}</div>
                                    <div class="label">{monthsLabel[this.state.today.getMonth()]}</div>
                                </div>
                            </div>
                            <div class="date-picker__after">
                                <div class="c-client-secondary">
                                    <div class="date">{this.state.tomorrow.getDate()}</div>
                                    <div class="label">{monthsLabel[this.state.tomorrow.getMonth()]}</div>
                                </div>
                            </div>
                            <div onClick={() => this.changeDate(1)} class="date-picker__button">
                                <div class="c-client-default">
                                    <i class="fa fa-angle-right"></i>
                                </div>
                            </div>
                        </div>
                        <div class="search-block-content p-20">
                            {/*<h5 class="ta-l">Onde prefere ser atendido?</h5>
                            <div class="peers">
                                <div onClick={() => this.setState({mode:"home"})} class="radio radio-client-default m-0 mR-10">
                                    <input type="radio" name="p-nome" id="radio-1" value="Mensal"/>
                                    <label for="radio-1">Domicílio</label>
                                </div>
                                <div onClick={() => this.setState({mode:"clinic"})} class="radio radio-client-default m-0 ">
                                    <input type="radio" name="p-nome" id="radio-2" value="Trimestral"/>
                                    <label for="radio-2">Clínica</label>
                                </div>
                            </div>*/}

                            

                            <div class="mT-15">
                                {/*<p class="fsx-xs m-0 lh-1 c-grey-600 ta-l">Você será atendido em:</p>*/}
                                    <h5 class="c-client-default m-0 w-100p clinic-title"><b>Venha para a Blues Copacabana!</b></h5>

                                <div class="peers jc-sb ai-c">
                                <div>
                                        <p class="m-0 lh-14 ta-l">Rua Constante Ramos, 44 - Cobertura 5</p>
                                        <p class="m-0 lh-14 ta-l">Bairro: Copacabana - Rio de Janeiro - RJ</p>
                                </div>
                                    {/*<div class="search-result-price">R$ 100,00 </div>*/}

                                </div>
                                <div class="home-schedule mT-15">
                                        <p class="fsx-xs mT-0 lh-1 c-grey-600">Horário do atendimento:</p>
                                    <div class="home-schedules">
                                        <div class="home-schedule-grid">
                                            {this.loadHourBoxes()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ta-c mT-20">
                                <a href="assets/#/checkout">
                                    <Link style={{marginTop:30}} to="/home/checkout" from={this.props.location} type="button"
                                        class="btn btn-quartenary fsz-md bdr-full  pX-30 pY-10">
                                        <b>Agende sua consulta</b>
                                    </Link>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default class Main extends React.Component{

    componentDidMount(){
        $("#schedule").click(function() {
            $('html, body').animate({
                scrollTop: $("#top-home").offset().top
            }, 1500);
        });

        $("#visit").click(function() {
            $('html, body').animate({
                scrollTop: $("#contact-form").offset().top
            }, 1500);
        });
    }

    render(){
        return(
            <div>
                <section id="top-home" style={{backgroundImage:"url('/assets/images/paciente.jpg')", backgroundPositionX: -50, backgroundColor:"#788E9B"}}>
                    <div class="top-content">
                        <div class="blues-content">

                            <div class="t-middle">
                            
                                <div class="t-middle__content">
                                    <div class="mB-30 mT-30">
                                        
                                        <h3 class="dark-blue m-0"><b>Um novo conceito em fisioterapia espera por você!</b></h3>
                                        <div class="c-client-default fsz-md mT-15 ai-c"> <b>Agende agora sua avaliação completa</b> <i class="fa fa-arrow-right fsz-lg mL-10 d-n@xs"></i></div>
                                    </div>
                                </div>
                                <AppointmentBox onChange={this.props.onChange}/>
                                </div>
                            </div>
                        </div>
                </section>

                <section id="welcome" class="bgc-grey-100">
                    <div class="peers w-100p h-100p jc-sb">
                        <div class="blues-content">
                            <h2 class="ta-c c-client-default">Seja bem-vindo<br/> ao novo conceito em <b
                                    class="c-client-default-secondary">fisioterapia</b></h2>
                            <div class="center-text">
                                <h5>A Blues nasceu com um objetivo que, apesar de simples, é difícil de ser observado no dia a dia:
                                    realizar atendimentos humanizados com foco no resultado. Venha para a Blues, queremos que você conheça a 
                                    <b> fisioterapia de verdade.</b></h5>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="banner-action" class="bgc-grey-100">
                    <div class="banner-action-middle">
                        <div class="banner-action-middle__content banner-image"
                            style={{backgroundImage: "url('/assets/images/img01.jpg')"}}>

                        </div>

                        <div class="banner-action-middle__content">
                            <div class="">
                                <div class="right bgc-client-default h-middle sz-500 p-30">
                                    <div>
                                        <h2 class="c-white m-0"><b>O mundo evolui e a fisioterapia também!</b></h2>
                                        <div class="banner-d-flex mT-30">
                                            <div class="medium-icon">
                                                <img src="/assets/images/icons/laptop.svg" />
                                            </div>
                                            <div>
                                                <h5 class="c-white mL-20">Através de nossa plataforma, Você poderá acompanhar o
                                                    tratamento
                                                    e sua evolução, terá acesso às fotos e vídeos feitos na avaliação e reavaliações,
                                                    receberá os deveres de casa e poderá acompanhar os pagamentos e as datas das
                                                    consultas.
                                                    Tudo isso no site Blues através da área do paciente.
                                                </h5>
                                                <p class="fsz-sm lh c-white mL-20">Todos os seus dados contidos no
                                                    site são protegidos, não se preocupe!</p>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </section>

                <section id="action-text" class="bgc-grey-100">
                    <div class="peers w-100p h-100p jc-sb">
                        <div class="blues-content">
                            <h2 class="ta-c c-client-default">Por que a <b>Blues</b>?</h2>
                            <h3 class="ta-c c-client-default">Aqui é fisioterapia mão na massa, chega de "choquinho", ultrassom e gelo!
                            </h3>
                            <div class="center-text">
                                <h5>Utilizamos as mais variadas técnicas manuais e os atendimentos são individuais e planejados
                                    especialmente para você, de acordo com suas necessidades.</h5>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="about">
                    <div class="peers w-100p h-100p jc-sb">
                        <div class="blues-content">
                            <h2 class="ta-c c-client-default"><b>Nossos valores</b> falam sobre a gente</h2>
                            <div class="three-content mT-50">
                                <div class="three-content__block mB-20 card">
                                    <div class="pX-20 h-100p pT-20">
                                        <div class="medium-icon">
                                            <img src="/assets/images/icons/heart.svg" />
                                        </div>
                                        <h5 class="c-client-default ta-c">É VOCÊ QUE NOS IMPORTA</h5>
                                        <p class="ta-c">Somos uma equipe dedicada, que não se importa só com a
                                            doença,
                                            mas
                                            com a
                                            pessoa como um todo.</p>
                                    </div>
                                </div>

                                <div class="three-content__block mB-20 card">
                                    <div class="pX-20 h-100p pT-20">
                                        <div class="medium-icon">
                                            <img src="/assets/images/icons/smile.svg" />
                                        </div>
                                        <h5 class="c-client-default ta-c">ABORDAGEM HUMANIZADA</h5>
                                        <p class="ta-c">Queremos promover o bem-estar tanto físico quanto emocional,
                                            proporcionando a melhor experiência para nossos clientes.</p>
                                    </div>

                                </div>

                                <div class="three-content__block mB-20 card">
                                    <div class="pX-20 h-100p pT-20">
                                        <div class="medium-icon">
                                            <img src="/assets/images/icons/doctor.svg" />
                                        </div>
                                        <h5 class="c-client-default ta-c">ATUALIZAÇÃO CONTÍNUA</h5>
                                        <p class="ta-c">Nos mantemos sempre atualizados, com os melhores tratamentos
                                            e as
                                            evidências mais recentes.</p>
                                    </div>
                                </div>

                                <div class="three-content__block mB-20 card">
                                    <div class="pX-20 h-100p pT-20">
                                        <div class="medium-icon">
                                            <img src="/assets/images/icons/hands.svg" />
                                        </div>
                                        <h5 class="c-client-default ta-c">A CASA TAMBÉM É SUA</h5>
                                        <p class="ta-c">Queremos que se sintam à vontade na clínica e estamos sempre
                                            prontos
                                            para ouvir.</p>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="cta-you-choose">
                    <div class="peers w-100p h-100p jc-sb">
                        <div class="blues-content">
                            <div class="t-middle">
                                <div class="t-middle__content">
                                    <div class="right">
                                        <h2 class="c-client-default m-0">Clínica ou domicílio?</h2>
                                        <h1 class="c-client-default m-0"><b class="c-client-default-secondary">Você escolhe!</b></h1>
                                    </div>
                                </div>
                                <div class="t-middle__content">
                                    <h5>Teremos o maior prazer em recebe-lo na Blues, com ótima localização e fácil acesso.
                                        Mas se preferir, nossa equipe vai até você!</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="ta-c">
                        <button type="button" id="schedule" class="btn btn-quartenary fsz-md bdr-full  pX-30 pY-10">
                            <b>Agende sua consulta</b>
                        </button>
                    </div>
                </section>
                <section class="banner-doctor" id="banner-action">
                    <div class="banner-action-middle">


                        <div class="banner-action-middle__content">
                            <div class="">
                                <div class="right bgc-grey-100 h-middle sz-500 p-30">
                                    <div>
                                        <div class="banner-d-flex mT-30">
                                            <div class="medium-icon">
                                                <img src="/assets/images/icons/stethoscope.svg" />
                                            </div>
                                            <h5 class="mL-20 pR-30">Buscamos uma relação direta e de longo prazo com
                                                os médicos,
                                                pois entendemos que quanto melhor a sinergia
                                                entre os profissionais
                                                de Medicina e Fisioterapia, melhor
                                                será o resultado do tratamento.

                                            </h5>


                                        </div>
                                        <div class="ta-c peers jc-c">
                                            <button id="visit" type="button"
                                                class="btn btn-outline-quartenary fsz-md bdr-full  mT-30 pX-30 pY-10 big-button-text">
                                                Profissional da Saúde? <b>Receba uma visita</b>
                                            </button>
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>
                        <div class="banner-action-middle__content banner-image"
                            style={{backgroundImage: "url(/assets/images/medico.jpeg)"}}>

                        </div>

                    </div>
                </section>

                {/*<section id="blog-action" class="bgc-grey-200">
                    <div class="peers w-100p h-100p jc-sb">
                        <div class="blues-content">
                            <div class="t-middle">
                                <div class="t-middle__content">
                                    <div class="right">
                                        <h2 class="c-client-default m-0"><b class="c-client-default">#NósCuidamos</b></h2>
                                        <h5 class=" m-0">Acompanhe todas as novidades da Blues em nosso Blog, além de
                                            informações e dicas sobre sua saúde e bem-estar.</h5>
                                    </div>
                                </div>
                                <div class="t-middle__content">
                                    <a href="/#/blog" class="btn btn-quartenary fsz-md bdr-full pX-30 pY-10">
                                        <b>BLOG da Blues</b>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
        </section>*/}
                <section id="contact-form" class="bgc-grey-100">
                    <div class="peers w-100p h-100p jc-sb">
                        <div class="blues-content">
                            <div class="t-middle">
                                <div class="t-middle__content t-top">
                                    <div class="right">
                                        <h2 class="c-client-default-tertiary m-0"><b>Está na hora de sorrir!</b></h2>
                                        <h5 class="c-client-default m-0">
                                            E se restou alguma dúvida, estamos aqui para esclarecer!</h5>
                                    </div>
                                </div>
                                <div class="t-middle__content">
                                    <form id="form-home">
                                        <div class="mB-10">
                                            <label>Nome completo</label>
                                            <input type="text" placeholder="nome" />
                                        </div>
                                        <div class="mB-10">
                                            <label>Telefone</label>
                                            <input type="text" placeholder="telefone" />
                                        </div>
                                        <div class="mB-10">
                                            <label>E-mail</label>
                                            <input type="text" placeholder="E-mail" />
                                        </div>
                                        <div class="mB-10">
                                            <label>Assunto</label>
                                            <textarea type="text" placeholder="Assunto"></textarea>
                                        </div>
                                        <div class="ta-c">
                                            <button type="submit" class="btn btn-quartenary fsz-md bdr-full  mT-10 pX-30 pY-10">
                                                <b>ENVIAR</b>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/home/pages/Main.js